const STATES = {
  UNSET: 'UNSET',
  NEW: 'NEW',
  CONFIRMED: 'CONFIRMED',
};

export { STATES };
